import {Component} from '@angular/core';
import {PrimeTemplate} from "primeng/api";
import {FormsModule} from "@angular/forms";
import {UserProperties, UserPropertiesService} from "../services/user-properties.service";
import {DynamicDialogConfig} from "primeng/dynamicdialog";
import {NgIf} from "@angular/common";
import {ButtonDirective} from "primeng/button";
import {IframeDialogComponent} from "../../shared/iframe-dialog/iframe-dialog.component";
import {SafeUrlPipe} from "../../shared/pipes/safe-url.pipe";

@Component({
    selector: 'app-onboarding',
    standalone: true,
    imports: [
        PrimeTemplate,
        FormsModule,
        NgIf,
        ButtonDirective,
        IframeDialogComponent,
        SafeUrlPipe
    ],
    templateUrl: './onboarding.component.html',
    styleUrl: './onboarding.component.scss'
})
export class OnboardingComponent {
    url = "https://imzaflow.de"

    isDontShowSelected: boolean = false;
    isOnboardingUserProperty!: UserProperties;
    isOpenedManually!: boolean;

    constructor(private userPropertiesService: UserPropertiesService, public dynamicDialogConfig: DynamicDialogConfig) {
        this.isOpenedManually = dynamicDialogConfig.data.isOpenedManually;
    }

    ngOnInit() {
        this.userPropertiesService.getByKey('sipo.settings.isonboarding').subscribe(res => {
            this.isOnboardingUserProperty = res;
            this.isDontShowSelected = res.userPropertyValue === 'true';
        })
    }

    ngOnDestroy() {
        this.isOnboardingUserProperty.userPropertyValue = this.isDontShowSelected ? 'true' : 'false';
        this.userPropertiesService.update(this.isOnboardingUserProperty).subscribe({
            next: () => {
                console.log('onboarding user has been updated');
            },
            error: err => {
                console.error('An error occurred while patching: ', err);
            }
        })
    }
}
